import { Controller, type UseFormReturn } from 'react-hook-form';
import type { ContentProfile } from '@content-planner/shared';
import { MultiChoice, SingleChoice } from './ChoiceGroup.js';
import { platformChoices, toneChoices } from './options.js';

type FormShape = ContentProfile & { month?: string };

export function StepRound2({ form }: { form: UseFormReturn<FormShape> }) {
  return (
    <div>
      <h2 className="mb-1">Where and how should it sound?</h2>
      <p className="text-text-secondary mb-6">
        Pick the platforms you actually post on. We won't fill out the rest.
      </p>

      <Controller
        name="platforms"
        control={form.control}
        rules={{ validate: (v) => (v && v.length > 0) || 'Pick at least one platform.' }}
        render={({ field, fieldState }) => (
          <MultiChoice
            legend="Which platforms?"
            choices={platformChoices}
            value={field.value ?? []}
            onChange={field.onChange}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="tone"
        control={form.control}
        rules={{ required: 'Pick a tone.' }}
        render={({ field, fieldState }) => (
          <SingleChoice
            name="tone"
            legend="What's the voice?"
            choices={toneChoices}
            value={field.value}
            onChange={field.onChange}
            error={fieldState.error?.message}
          />
        )}
      />

      <label className="block mb-6">
        <span className="font-heading font-semibold text-base">Anything to avoid?</span>
        <span className="block text-sm text-text-secondary mb-2">
          Topics, angles, or words you don't want in the plan. Leave blank if none.
        </span>
        <textarea
          rows={3}
          maxLength={500}
          className="gcm-input"
          placeholder="e.g. no politics, no discounts, no client names"
          {...form.register('avoid', { maxLength: 500 })}
        />
      </label>
    </div>
  );
}
